import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'eventData',
  name: 'eventData',
  initialState: {
    data : {}
  },
  reducers: {
    addState(state, action) {
      state.data = action.payload[0] || {};
    },
  },
});

export { actions as eventDataActions };
export { reducer as eventDataReducer };